import React, { Component } from 'react'
import { Paper, Typography } from '@mui/material'
import { CONFLICT_PARTICIPANT_TYPE } from './ConflictsView';
// createdAt, content, senderType
export class ConflictMessageDisplay extends Component {
    // shouldComponentUpdate(){
    //     return false;
    // }
    // constructor(props) {
    //     super(props);
    //     console.log("ConflictMessageDisplay: ", props.data);
        // this.state = {
        //     backgroundColor: "#FF9C51",
        //     borderColor: "#ED934E",
        //     textColor: "#FFFFFF",
        //     title: "",
        // }
    // }
    getTextColor = () => {
        switch (this.props.data.type) {
            case "1":
                return "#FFFFFF";
            case "2":
                return "#FFFFFF";
            case "3":
                return "#1D1D1D";
        }
    }
    getBackgroundColor = () => {
        switch (this.props.data.type) {
            case "1":
                return "#FF9C51";
            case "2":
                return "#4888FF";
            case "3":
                return "#FFFFFF";
        }
    }
    getBorderColor = () => {
        switch (this.props.data.type) {
            case "1":
                return "#ED934E";
            case "2":
                return "#4B80E2";
            case "3":
                return "#E0E0E0";
        }
    }
    render() {
        return (
            <div key={new Date(this.props.data.createDate).getTime()} style={{width:"100%", display:"flex", justifyContent: this.props.data.type === CONFLICT_PARTICIPANT_TYPE.SUPPORT ? "right" : "left"}}>
                <Paper elevation={3} style={{ width: "70%", maxWidth:400, padding: 15, marginTop: 25, borderRadius: 10, display: "flex", flexDirection: "column", backgroundColor: this.getBackgroundColor(), border: "0.5px solid " + this.getBorderColor()  }}>
                    <Typography style={{color: this.getTextColor(), textAlign:"center", fontWeight:"bold"}}>{this.props.data.type === "1" ? "Kunde" : this.props.data.type === "2" ? "Support" : "Shop"}</Typography>
                    <Typography style={{ color: this.getTextColor(), whiteSpace:'pre-line', marginTop: 15}} fontSize="small">{this.props.data.message}</Typography>
                    <Typography style={{ color: this.getTextColor(),  textAlign: "right" }} fontSize="small">{new Date(this.props.data.createDate).toLocaleTimeString("de", { hour: "2-digit", minute: "2-digit", hour12: false })}</Typography>
                </Paper>
            </div>
        )
    }
}

export default ConflictMessageDisplay
